import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { useDeleteMutation } from '../../hooks/useAuthenticatedMutation';
import useSnackbar from '../../hooks/useSnackbar';

const DeleteFieldDialog = ({ field, onClose }) => {
    const { showSnackbar } = useSnackbar();
    const deleteMutation = useDeleteMutation(`custom-fields/${field.id}`, 'custom-fields');

    const handleDeleteField = () => {
        const onError = (error) => {
            const message = error.data.message || 'Could not update custom field';

            showSnackbar(message, 'error');
        };

        deleteMutation.mutate({ onSuccess: onClose, onError });
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>Delete Custom Field</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You are about to delete '{field.name}'.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleDeleteField}
                    loading={deleteMutation.isPending}
                    loadingPosition="start"
                >
                    OK
                </Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteFieldDialog;